import { createApi } from "@reduxjs/toolkit/query/react";
import { prepareBaseQuery } from "./baseQueryWithReauth";

const equipmentApi = createApi({
  reducerPath: "equipment",
  baseQuery: prepareBaseQuery("/equipment/"),
  tagTypes: ["Equipment"],
  endpoints: (builder) => ({
    getEquipment: builder.query({
      query: (params = {}) => ({
        url: "",
        method: "GET",
        params,
      }),
      providesTags: (result) =>
        result?.items
          ? [
              ...result.items.map((i) => ({ type: "Equipment", id: i._id })),
              { type: "Equipment", id: "LIST" },
            ]
          : [{ type: "Equipment", id: "LIST" }],
    }),
    getEquipmentStats: builder.query({
      query: (params = {}) => ({
        url: "stats",
        method: "GET",
        params,
      }),
      providesTags: [{ type: "Equipment", id: "STATS" }],
    }),
    createEquipment: builder.mutation({
      query: (body) => ({
        url: "",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Equipment", id: "LIST" }, { type: "Equipment", id: "STATS" }],
    }),
    updateEquipment: builder.mutation({
      query: ({ id, body }) => ({
        url: `${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (res, err, { id }) => [
        { type: "Equipment", id },
        { type: "Equipment", id: "LIST" },
        { type: "Equipment", id: "STATS" },
      ],
    }),
    deleteEquipment: builder.mutation({
      query: (id) => ({
        url: `${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (res, err, id) => [
        { type: "Equipment", id },
        { type: "Equipment", id: "LIST" },
        { type: "Equipment", id: "STATS" },
      ],
    }),
    archiveEquipment: builder.mutation({
      query: (id) => ({
        url: `${id}/archive`,
        method: "PATCH",
      }),
      invalidatesTags: (res, err, id) => [
        { type: "Equipment", id },
        { type: "Equipment", id: "LIST" },
        { type: "Equipment", id: "STATS" },
      ],
    }),
    restoreEquipment: builder.mutation({
      query: (id) => ({
        url: `${id}/restore`,
        method: "PATCH",
      }),
      invalidatesTags: (res, err, id) => [
        { type: "Equipment", id },
        { type: "Equipment", id: "LIST" },
        { type: "Equipment", id: "STATS" },
      ],
    }),
  }),
});

export const {
  useGetEquipmentQuery,
  useCreateEquipmentMutation,
  useUpdateEquipmentMutation,
  useArchiveEquipmentMutation,
  useRestoreEquipmentMutation,
  useDeleteEquipmentMutation,
  useGetEquipmentStatsQuery,
} = equipmentApi;

export default equipmentApi;
